import { Select } from "antd"
import { useEffect, useState } from 'react';
import { getCities } from "../../../../controllers/entities";
import { SizeType } from "antd/es/config-provider/SizeContext";

interface Props  {
    onChange: (value : string) => void,
    selectedState? : string
    placeholder? : string,
    onSearch?: (value : string) => void,
    disabled? : boolean,
    size? : SizeType,
    defaultValue? : string,
    style? : any,
    onClear : () => void,
}
const filterOption = (input: string, option?: { label: string; value: string }) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase());

const SelectCities= (props: Props) => {
    const [cities, setCities] = useState([]);
    useEffect(() => {
        const getcities = async () => {
            const cities:any =  getCities();
            if(props.selectedState){
                setCities(cities.filter((e:any)=>e.c_digo_dane_del_departamento === props.selectedState).map((c: any) => {
                    return {
                        value: c.c_digo_dane_del_municipio,
                        label: c.municipio
                    }
                }));
            }else{
                setCities(cities.map((c: any) => {
                    return {
                        value: c.c_digo_dane_del_municipio,
                        label: c.municipio
                    }
                })); 
            }
        }
        getcities()
    }, [props.selectedState]);
    
    return (
        <div style={{width : '100%'}}>
            <Select
               {...props}
                placeholder={props.placeholder || 'Ciudad'}
                showSearch
                optionFilterProp="children"
                filterOption={filterOption}
                labelInValue
                allowClear
                size={props.size}
                defaultValue={props?.defaultValue}
                onClear={() => {
                    if(props.onClear){
                        props?.onClear();
                    }
                }}
                style={props.style}
                onChange={(value:any) =>{
                    if(value){
                        props.onChange(value)
                    }
                }}
                options={cities}
            />        
        </div>
    );
}

export default SelectCities